import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DropDownItem } from 'app/interfaces/items/dropDownItem';
import { ExposedPaycheckRunsRes } from 'app/interfaces/responses/Exposed/exposedPaycheckRunsRes';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { PensionService } from 'app/services/api/pension/pension.service';

@Component({
    selector: 'pension-paycheck-runs',
    templateUrl: './pension-paycheck-runs.component.html',
    styleUrls: ['./pension-paycheck-runs.component.scss'],
})
export class PensionPaycheckRunsComponent implements OnInit {
    //#region Globals

    userDetails: ExposedReadUserDetailsRes = null;

    // Table
    pageSize: number = 25;
    pageNumber: number = 0;
    pageSizes = [5, 10, 25, 50, 100];
    dataSource = new MatTableDataSource<ExposedPaycheckRunsRes>();
    runsData: ExposedPaycheckRunsRes[] = [];
    totalData: number = 0;
    tableColumns: string[] = [];
    isLoading: boolean = true;
    @ViewChild('paginator') paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // Form
    form: UntypedFormGroup;
    fundDropdown: DropDownItem[] = [{ value: '', viewValue: 'Allir sjóðir' }];

    //#endregion

    //#region Init

    constructor(
        private pensionService: PensionService,
        private formBuilder: UntypedFormBuilder,
        public dialog: MatDialog,
        public lsrauthService: LsrauthService
    ) {
        this.lsrauthService.userDetails.subscribe((userDetails) => (this.userDetails = userDetails));
    }

    ngOnInit(): void {
        this.initTableColumns();
        this.initForm();
    }

    initForm() {
        let dateFrom = new Date();
        dateFrom.setMonth(dateFrom.getMonth() - 6);

        this.form = this.formBuilder.group({
            searchString: new UntypedFormControl(''),
            dateFrom: new UntypedFormControl(new Date(dateFrom.toDateString()), [Validators.required]),
            dateTo: new UntypedFormControl(new Date(new Date().toDateString()), [Validators.required]),
            fund: new UntypedFormControl(''),
        });
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
        this.fetchRuns(this.pageNumber, this.pageSize);
    }

    fetchRuns(pageNumber: number, pageSize: number) {
        this.isLoading = true;

        let dateFrom = new Date(this.form.get('dateFrom').value);
        dateFrom.setUTCHours(0, 0, 0, 0);
        let dateTo = new Date(this.form.get('dateTo').value);
        dateTo.setUTCHours(23, 59, 59, 999);

        let searchString = this.form.get('searchString').value;

        this.pensionService
            .getPaycheckRuns(pageNumber, pageSize, searchString, dateFrom, dateTo, true)
            .then((paged) => {
                this.runsData = paged.items ?? [];
                this.dataSource.data = this.runsData;
                this.totalData = paged.totalCount ?? 0;
                this.pageSize = pageSize;
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    search() {
        this.pageNumber = 0;
        if (this.paginator) this.paginator.firstPage();
        this.fetchRuns(this.pageNumber, this.pageSize);
    }

    //#endregion

    //#region Table functions

    initTableColumns() {
        this.tableColumns = ['registeredOn', 'paycheckRunId', 'title', 'printableCount', 'actions'];
    }

    pageChanged(event: PageEvent) {
        this.pageSize = event.pageSize;
        this.pageNumber = event.pageIndex;
        this.fetchRuns(this.pageNumber, this.pageSize);
    }

    //#endregion

    //#region Helper methods

    openPostalPrint(run: ExposedPaycheckRunsRes) {
        this.pensionService.createPostalShareLink(run.paycheckRunId, 500).then((res) => {
            // user gesture click → window.open should not be popup-blocked
            window.open(res.url, '_blank', 'noopener,noreferrer');
        });
    }

    //#endregion
}
